import { EuroCoinIcon, GiftIcon, ShoppingCartIcon, TruckIcon } from '@synergy/theme-next';
import { FormattedMessage } from 'react-intl';
import {
    PoolAccordion,
    PoolAccordionDetails,
    PoolAccordionItem,
    PoolAccordionSummary,
    PoolTypography,
} from '@synergy/components-next';
import { ReactElement } from 'react';
import { Stack } from '@mui/material';

import { BonusConditionsPresenter } from '../../../components/bonus-conditions-presenter/bonus-condition-presenter';
import { PaymentTermText } from '../../../components/payment-term-text/payment-term-text';
import { useArticleDetailContext } from '../article-detail';

export const ArticleDetailSupplierConditions = (): ReactElement | null => {
    const { article } = useArticleDetailContext();
    const { supplier } = article;

    return (
        <Stack gap={2}>
            <PoolTypography variant="h5">{supplier.name}</PoolTypography>

            <PoolAccordion activeIndex={supplier.termsOfDelivery ? 0 : undefined}>
                <PoolAccordionItem disabled={!supplier.termsOfDelivery}>
                    <PoolAccordionSummary>
                        <TruckIcon />
                        <FormattedMessage id="app.supplier.termsOfDelivery" />
                    </PoolAccordionSummary>
                    <PoolAccordionDetails>{supplier.termsOfDelivery}</PoolAccordionDetails>
                </PoolAccordionItem>

                <PoolAccordionItem disabled={!supplier.paymentTerm && !supplier.isChargingSupplier}>
                    <PoolAccordionSummary>
                        <EuroCoinIcon />
                        <FormattedMessage id="app.supplier.termsOfPayment" />
                    </PoolAccordionSummary>
                    <PoolAccordionDetails>
                        <PaymentTermText
                            isChargingSupplier={supplier.isChargingSupplier}
                            paymentTerm={supplier.paymentTerm}
                        />
                    </PoolAccordionDetails>
                </PoolAccordionItem>

                <PoolAccordionItem disabled={!supplier.conditionsOfPurchase}>
                    <PoolAccordionSummary>
                        <ShoppingCartIcon />
                        <FormattedMessage id="app.supplier.conditionsOfPurchase" />
                    </PoolAccordionSummary>
                    <PoolAccordionDetails>{supplier.conditionsOfPurchase}</PoolAccordionDetails>
                </PoolAccordionItem>

                <PoolAccordionItem disabled={article.supplierConditions.length === 0}>
                    <PoolAccordionSummary>
                        <GiftIcon />
                        <FormattedMessage id="app.article.detail.poolBonus" />
                    </PoolAccordionSummary>
                    <PoolAccordionDetails>
                        <BonusConditionsPresenter supplierConditions={article.supplierConditions} />
                    </PoolAccordionDetails>
                </PoolAccordionItem>
            </PoolAccordion>
        </Stack>
    );
};
